import { CSSProperties } from "react";

export const styles: Record<string, CSSProperties> = {
  iframe: {
    width: 0,
    height: 0,
    opacity: 0,
  },
  subtitle: {
    textAlign: "center",
  },
};
